import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import { Navigate, useNavigate } from "react-router-dom";
import BarChartIcon from "@mui/icons-material/BarChart";
import PeopleIcon from "@mui/icons-material/People";
import MapIcon from "@mui/icons-material/Map";
import GpsFixedIcon from "@mui/icons-material/GpsFixed";
import BlurOnIcon from "@mui/icons-material/BlurOn";
import ScatterPlotIcon from "@mui/icons-material/ScatterPlot";
import ExploreIcon from "@mui/icons-material/Explore";
import { useAuth } from "@/auth/AuthContext";

export default function ReportsHome() {
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  if (loading) return null;
  if (!user?.is_superuser) return <Navigate to="/search" replace />;

  return (
    <Box sx={{ px: 2, pb: 3 }}>
      <Stack spacing={2}>
        <Paper elevation={1} sx={{ p: 2 }}>
          <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
            <Stack spacing={0.5}>
              <Typography variant="subtitle1">Maps</Typography>
              <Typography variant="body2" color="text.secondary">
                View note locations and stats.
              </Typography>
            </Stack>
            <Button variant="contained" startIcon={<MapIcon />} onClick={() => navigate("/reports/maps")}>
              Open
            </Button>
          </Stack>
        </Paper>

        <Paper elevation={1} sx={{ p: 2 }}>
          <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
            <Stack spacing={0.5}>
              <Typography variant="subtitle1">Coverage Report</Typography>
              <Typography variant="body2" color="text.secondary">
                Clustered view of all visited addresses.
              </Typography>
            </Stack>
            <Button variant="contained" startIcon={<GpsFixedIcon />} onClick={() => navigate("/reports/coverage")}>
              Open
            </Button>
          </Stack>
        </Paper>

        <Paper elevation={1} sx={{ p: 2 }}>
          <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
            <Stack spacing={0.5}>
              <Typography variant="subtitle1">Coverage Report – Dynamic Clusters</Typography>
              <Typography variant="body2" color="text.secondary">
                Cluster bubbles resize based on spread of points.
              </Typography>
            </Stack>
            <Button variant="contained" startIcon={<ScatterPlotIcon />} onClick={() => navigate("/reports/coverage-clusters")}>
              Open
            </Button>
          </Stack>
        </Paper>

        <Paper elevation={1} sx={{ p: 2 }}>
          <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
            <Stack spacing={0.5}>
              <Typography variant="subtitle1">Coverage Report – Heatmap</Typography>
              <Typography variant="body2" color="text.secondary">
                Heatmap layer to visualise density.
              </Typography>
            </Stack>
            <Button variant="contained" startIcon={<BlurOnIcon />} onClick={() => navigate("/reports/coverage-heatmap")}>
              Open
            </Button>
          </Stack>
        </Paper>

        <Paper elevation={1} sx={{ p: 2 }}>
          <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
            <Stack spacing={0.5}>
              <Typography variant="subtitle1">Coverage Report – MapLibre + deck.gl</Typography>
              <Typography variant="body2" color="text.secondary">
                Prototype using MapLibre base map with deck.gl heatmap, clusters, and points.
              </Typography>
            </Stack>
            <Button variant="contained" startIcon={<ExploreIcon />} onClick={() => navigate("/reports/coverage-maplibre")}>
              Open
            </Button>
          </Stack>
        </Paper>

        <Paper elevation={1} sx={{ p: 2 }}>
          <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
            <Stack spacing={0.5}>
              <Typography variant="subtitle1">Status</Typography>
              <Typography variant="body2" color="text.secondary">
                Status breakdown by day/week/month.
              </Typography>
            </Stack>
            <Button variant="contained" startIcon={<BarChartIcon />} onClick={() => navigate("/reports/status")}>
              Open
            </Button>
          </Stack>
        </Paper>

        <Paper elevation={1} sx={{ p: 2 }}>
          <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
            <Stack spacing={0.5}>
              <Typography variant="subtitle1">Agent</Typography>
              <Typography variant="body2" color="text.secondary">
                Compare agents over time.
              </Typography>
            </Stack>
            <Button variant="contained" startIcon={<PeopleIcon />} onClick={() => navigate("/reports/agent")}>
              Open
            </Button>
          </Stack>
        </Paper>
      </Stack>
    </Box>
  );
}
